import moment, { Moment } from 'moment'

import { Person } from '../../../App/store/features/person/IPerson'

export const getSchemaWeekForDateAndPerson = (
  date: Moment,
  person: Person,
): number => {
  const schemaWeekStartedAt = moment(person.schemaWeekStartedAt)
    .clone()
    .startOf('day')
    .isoWeekday(date.isoWeekday())

  return (
    (date.clone().startOf('day').diff(schemaWeekStartedAt, 'weeks') %
      person.schemaWeeks) +
    1
  )
}
